function imageZoom(){

    "use strict";

    $('.no-touchevents .fabric-module__image')
    // tile mouse actions
        .on('mouseover', function(){
            $(this).children('.fabric-module__image--zoom').css({'transform': 'scale(2.8)'});
        })
        .on('mouseout', function(){
            $(this).children('.fabric-module__image--zoom').css({'transform': 'scale(1)'});
        })
        .on('mousemove', function(e){
            $(this).children('.fabric-module__image--zoom').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
        })

}

module.exports = imageZoom;


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/components/global/13_zoom.js